function generate_image_sources(canvas) {
    return [
    // Gallery images
    {
        room_id: 1, 
        initial_dx: canvas.width/2.5-100,
        initial_dy: canvas.width/2.5-10,
        src: require("/assets//gallery_1_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 1,
        initial_dx: canvas.width/3.5-90,
        initial_dy: canvas.width/2.5-30,
        src: require("/assets//gallery_1_1.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 2,
        initial_dx: canvas.width/5+650,
        initial_dy: canvas.width/2-700,
        src: require("/assets//gallery_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 3,
        initial_dx: canvas.width/3.5-5,
        initial_dy: -canvas.width/3,
        src: require("/assets//gallery_3_1.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 3,
        initial_dx: canvas.width/3.5+100,
        initial_dy: -canvas.width/2+170,
        src: require("/assets//gallery_3_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 4,
        initial_dx: -canvas.width/2+350,
        initial_dy: -canvas.width/2+100,
        src: require("/assets//gallery_4_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 4,
        initial_dx: -canvas.width/2+500,
        initial_dy: -canvas.width/2+150,
        src: require("/assets//gallery_4_1.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 5,
        initial_dx: canvas.width/2+300,
        initial_dy: -canvas.width/5-300,
        src: require("/assets//gallery_5.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 6,
        initial_dx: -canvas.width/2-400,
        initial_dy: -canvas.width/5-200,
        src: require("/assets//gallery_6.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 7,
        initial_dx: -canvas.width/2-400,
        initial_dy: canvas.width/3-650,
        src: require("/assets//gallery_7_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 7,
        initial_dx: -canvas.width/2-340,
        initial_dy: canvas.width/3-550,
        src: require("/assets//gallery_7_1.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 8,
        initial_dx: -canvas.width/2+170,
        initial_dy: -canvas.width/2+500,
        src: require("/assets//gallery_8_1.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 8,
        initial_dx: -canvas.width/2+60,
        initial_dy: -canvas.width/2+650,
        src: require("/assets//gallery_8_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 9,
        initial_dx: -canvas.width/2-500,
        initial_dy: canvas.width/2-350,
        src: require("/assets//gallery_9_1.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 9,
        initial_dx: -canvas.width/2-350,
        initial_dy: canvas.width/2-450,
        src: require("/assets//gallery_9_2.jpg"),
        type: "gallery_img"
    },
    {
        room_id: 10,
        initial_dx: -canvas.width/2+340,
        initial_dy: canvas.width/2-550,
        src: require("/assets//gallery_10.jpg"),
        type: "gallery_img"
    }, 
    {
        room_id: 11,
        initial_dx: canvas.width/5+800,
        initial_dy: canvas.width/2-350,
        src: require("/assets//gallery_11.jpg"),
        type: "gallery_img"
    },   
    {
        room_id: 12,
        initial_dx: canvas.width/-2-30,
        initial_dy: canvas.width/2-150,
        src: require("/assets//gallery_12.png"),
        type: "gallery_img"
    },
    {
        room_id: 13,
        initial_dx: canvas.width/4+700,
        initial_dy: -canvas.width/4+10,
        src: require("/assets//gallery_13.jpg"),
        type: "gallery_img"
    }, 
    {
        room_id: 14,
        initial_dx: canvas.width/5+400,
        initial_dy: canvas.width/2-1000,
        src: require("/assets//gallery_14.jpg"),
        type: "gallery_img"
    }, 
    {
        room_id: 15,
        initial_dx: canvas.width/5-700,
        initial_dy: canvas.width/2-300,
        src: require("/assets//gallery_15.jpg"),
        type: "gallery_img"
    }, 

    // Room images
    {
        room_id: 1,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_1_1.jpg"),
        artist: "Diana Toloza",
        technique: "Photography",
        name: "Untitled",
        country: "Colombia",
        description: "",
        type: "room_img"
    },
    {
        room_id: 1,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_1_2.jpg"),
        artist: "Diana Toloza",
        technique: "Photography,",
        name: "Untitled",
        country: "Colombia",
        description: "",
        type: "room_img"
    },
    {
        room_id: 1,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_1_3.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 36X24cm",
        name: "Jaffa, 2014",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 1,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_1_4.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography",
        name: "Stigmata, 2012",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 1,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_1_5.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography",
        name: "Self-portrait, 2012",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 1,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_1_6.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 36X24cm",
        name: "Untitled, 2012",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 2,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_2_1.jpg"),
        artist: "Natalia Evelyn Bencicova and Enes Guc",
        technique: "",
        name: "Untitled,",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 2,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_2_2.jpg"),
        artist: "Natalia Evelyn Bencicova and Enes Guc" ,
        technique: "",
        name: "Untitled",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 2,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_2_3.jpg"),
        artist: "NNatalia Evelyn Bencicova and Enes Guc",
        technique: "",
        name: "Untitled",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 2,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_2_4.jpg"),
        artist: "Natalia Evelyn Bencicova and Enes Guc",
        technique: "",
        name: "Untitled",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 3,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_3_1.jpg"),
        artist: "Michael Liani",
        technique: "Gelatin, inkjet, 90x60 cm (ellipse)",
        name: "Ori in wonderland ,2019",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 3,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_3_2.jpg"),
        artist: "Michael Liani",
        technique: "Gelatin, tappet, 110x80 cm",
        name: "Sperm donation, 2019",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 3,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_3_3.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, Archival inkjet 40x60cm",
        name: "Untitled",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 3,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_3_4.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, Archival inkjet 86x130cm",
        name: "Untitled",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 4,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_4_1.jpg"),
        artist: "Itzik Mor",
        technique: "Photography Pigmented Inkjet Print, 80x80cm",
        name: "Xen ,2019 ,1/6",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 4,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_4_2.jpg"),
        artist: "Itzik Mor",
        technique: "Photography gelatin silver print, 50x40cm",
        name: "Mother-in-law tongue, 1/6",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 4,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_4_3.jpg"),
        artist: "Itzik Mor",
        technique: "Photography Pigmented Inkjet Print, 25x30cm",
        name: "Placement, 1/6",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 4,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_4_4.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, 40x60cm",
        name: "Untitled, Dandelion (2019)",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 4,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_4_5.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, 40x60cm",
        name: "Untitled, Wild Poppy (Tiberias) 2017",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 4,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_4_6.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, 40x60cm",
        name: "Untitled, Quail egg (2017)",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 6,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_6_1.jpg"),
        artist: "Diana Toloza",
        technique: "Photography",
        name: "Untitled",
        country: "Colombia",
        description: "",
        type: "room_img"
    },
    {
        room_id: 6,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_6_2.jpg"),
        artist: "Diana Toloza",
        technique: "Photography",
        name: "Untitled",
        country: "Colombia",
        description: "",
        type: "room_img"
    },
    {
        room_id: 6,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_6_3.jpg"),
        artist: "Diana Toloza",
        technique: "Photography",
        name: "Untitld",
        country: "Colombia",
        description: "",
        type: "room_img"
    },
    {
        room_id: 7,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_7_1.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, 40x60cm",
        name: "Untitled",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 7,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_7_2.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, 60x40cm",
        name: "Pigeon",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 7,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_7_3.jpg"),
        artist: "Anastasya Chernyak",
        technique: "Archival inkjet, 40x60cm",
        name: "Untitled, Wedding Veil (1986.16.03)",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 8,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_1.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 97X120cm",
        name: "My Dad, 2014",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 8,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_2.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 36X24cm",
        name: "My love, 2015",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 8,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_3.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 36X24cm",
        name: "Untitled, 2011",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 8,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_4.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 40X30cm",
        name: "Untitled, 2011",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 8,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_5.jpg"),
        artist: "Yuval Atzili",
        technique: "Photography, 300x200cm",
        name: "Untitled, 2013",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 8,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_6.jpg"),
        artist: "Michael Liani",
        technique: "Gelatin, tapet, 130x100cm ",
        name: "Nitzanim, 2018",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 5,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_7.jpg"),
        artist: "Michael Liani",
        technique: "Gelatin, photo collage, 87x107 cm",
        name: "Untitled, 2014, 1/5",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 5,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_8_8.jpg"),
        artist: "Michael Liani",
        technique: "Gelatin, photo collage, 87x107cm",
        name: "Untitled, 2014, 1/5",
        country: "Israel",
        description: "",
        description: "",
        type: "room_img"
    },
    {
        room_id: 9,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_9_1.jpg"),
        artist: "Enrique Freaza Viera",
        technique: "Embroidered polaroids",
        name: "Masks 02, Anja's Mask",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 9,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_9_2.jpg"),
        artist: "Enrique Freaza Viera",
        technique: "Embroidered polaroids",
        name: "Masks 04, Peter's Mask",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 9,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_9_3.jpg"),
        artist: "Enrique Freaza Viera",
        technique: "Embroidered polaroids",
        name: "Masks 06, Tom's Mask",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 11,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_11_1.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 01",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 11,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_11_2.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 02",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 11,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_11_3.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 03",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 11,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_11_4.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift,12x17cm",
        name: "Home 06",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 11,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_11_5.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 08",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 12,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_12_1.jpg"),
        artist: "Romy Engel",
        technique: "Digital photography",
        name: "Self (Isolation) Portrait 02,2020",
        country: "New York",
        description: "",
        type: "room_img"
    },
    {
        room_id: 12,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_12_2.jpg"),
        artist: "Romy Engel",
        technique: "Digital photography",
        name: "Self (Isolation) Portrait 05,2020",
        country: "New York",
        description: "",
        type: "room_img"
    },
    {
        room_id: 12,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_12_3.jpg"),
        artist: "Romy Engel",
        technique: "Digital photography",
        name: "Self (Isolation) Portrait 04,2020",
        country: "New York",
        description: "",
        type: "room_img"
    },
    {
        room_id: 12,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_12_4.jpg"),
        artist: "Romy Engel",
        technique: "Digital photography",
        name: "Self (Isolation) Portrait 03,2020",
        country: "New York",
        description: "",
        type: "room_img"
    },
    {
        room_id: 12,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_12_5.jpg"),
        artist: "Noa Macabbi",
        technique: "Digital photography",
        name: "Untitled, 2015",
        country: "Israel",
        description: "",
        type: "room_img"
    },
    {
        room_id: 13,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_13_1.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 05",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 13,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_13_2.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 09",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 13,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_13_3.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 04",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 13,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_13_4.jpg"),
        artist: "Urizen Freaza, Alla Sorokina,<br/> Déborah Kempczynski, Fabienne Forel,<br/>  Julian Ochoa, Luis Preto, <br/> Marta Wlusek, Zaida Kersten",
        technique: "Embroidery on emulsion lift, 12x17cm",
        name: "Home 07",
        country: "Germany",
        description: "",
        type: "room_img"
    },
    {
        room_id: 13,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_13_5.jpg"),
        artist: "",
        technique: "",
        name: "",
        country: "",
        description: "",
        type: "room_img"
    },
    {
        room_id: 14,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_14_1.jpg"),
        artist: "Vegetal Import Festival ֿ\"poster\"",
        technique: "Limited edition 20 es, 50 x 70cm",
        name: "",
        country: "Italy",
        description: "",
        dont_rotate: true,
        dont_pad: true,
        type: "room_img"
    },
    {
        room_id: 14,
        initial_dx: 0,
        initial_dy: 0,
        src: require("/assets//room_14_2.jpg"),
        artist: "Vegetal Import Festival ֿ\"poster\"",
        technique: "Limited edition 20 es, 50 x 70cm",
        name: "",
        country: "Italy",
        description: "",
        dont_rotate: true,
        type: "room_img"
    },
    // Room videos
    {
        room_id: 2,
        src: "https://player.vimeo.com/video/406597644",
        height: 488,
        width: 1080,
        artist: "Shira Kela",
        technique: "Video, 05:48min",
        name: "Zygota",
        country: "Germany",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 3,
        src: "https://player.vimeo.com/video/228784352",
        height: 488,
        width: 1080,
        artist: "Cooike Moon",
        technique: "Video 12:49min",
        name: "Undercurrent,2017",
        country: "Israel",
        description: "'",
        type: "room_vid"
    },
    {
        room_id: 5,
        src: "https://www.youtube.com/embed/P0uvrNPMV1o",
        height: 500,
        width: 760,
        artist: "Natalie Feldesman",
        technique: "Video, 00:52min",
        name: "Egypt",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 5,
        src: "https://www.youtube.com/embed/0bwXFuNpMUA",
        height: 500,
        width: 760,
        artist: "Natalie Feldesman",
        technique: "Video, 01:40min",
        name: "Talia ",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 4,
        src: "https://www.youtube.com/embed/WAO3m4BvelE",
        height: 500,
        width: 760,
        artist: "Natalie Feldesman",
        technique: "Video, 00:43min",
        name: "Itzik",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 1,
        src: "https://www.youtube.com/embed/lEitq9Coyyk",
        height: 500,
        width: 760,
        artist: "Natalie Feldesman",
        technique: "Video, 02:31min",
        name: "Me",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 6,
        src: "https://www.youtube.com/embed/yN6_b1JQsLk",
        height: 500,
        width: 760,
        artist: "Shy Ben Ari",
        technique: "Digital collage, 00:17min",
        name: "Loving online",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 7,
        src: "https://player.vimeo.com/video/167339685",
        height: 488,
        width: 1080,
        artist: "Yuval Atzili",
        technique: "Video",
        name: "Yuval and Gal, 01:0min",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 8,
        src: "https://www.youtube.com/embed/bpK0zywCW_0",
        height: 400,
        width: 700,
        artist: "Maya Agam",
        technique: "Video",
        name: "Intimacy, 00:12min",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 10,
        src: "https://www.youtube.com/embed/JVGJnu2Jqng",
        height: 400,
        width: 700,
        artist: "Natalie Feldesman",
        technique: "Video, 05:36min",
        name: "A Snake In The Garden",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 9,
        src: "https://www.youtube.com/embed/B2ZFcvWR7ac",
        height: 450,
        width: 550,
        artist: "Shy Ben Ari",
        technique: "Digital collage, 00:11min",
        name: "Watching Rom-Com",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 13,
        src: "https://player.vimeo.com/video/410125274",
        height: 450,
        width: 800,
        artist: "Arava Assaf",
        technique: "Painting and video, 02:16min",
        name: "Shavshevet (Weather vane)",
        country: "Israel",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 14,
        src: "https://player.vimeo.com/video/260638765",
        height: 450,
        width: 800,
        artist: "Vegetal Import Festival \"video conference\"",
        technique: "Giulia Currà, audio: Steve Piccolo",
        name: "video color/ 15 minutes",
        country: "Italy",
        description: "",
        type: "room_vid"
    },
    {
        room_id: 15,
        src: "https://player.vimeo.com/video/344362296",
        height: 450,
        width: 800,
        artist:"Orly Anan",
        technique: "Video, 15:12min",
        name: "BocaaBoca",
        country: "Mexico",
        description: "",
        type: "room_vid"
    },
    ]
}
export default generate_image_sources
